// Copyright (c) 2023 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.

const aliasSettings = {
    aliasEnabled: false,
    aliasPaymentAddress: 'ecash:prfhcnyqnl5cgrnmlfmms675w93ld7mvvqd0y8lz07',
    aliasServerBaseUrl: 'https://alias.bytesofman.com',
    aliasMaxLength: 21, // max byte length, refer to the Alias spec at https://reviews.bitcoinabc.org/D12972
    aliasKeyUpTimeoutMs: 1000,
};

export default aliasSettings;
